"use client";

import {BaseAppPrefs} from "../shared/BaseAppPrefs";

export class SharedPrefs extends BaseAppPrefs {

  private static instance: SharedPrefs;

  static getInstance(): SharedPrefs {
    if (!this.instance) {
      this.instance = new SharedPrefs();
    }
    return this.instance;
  }

  static readonly PREF_NOTIF_TOKEN = "notif_token";

  getNotifcationToken(): string {
    return this.prefs.getString(SharedPrefs.PREF_NOTIF_TOKEN, null);
  }

  setNotificationToken(token: string): void {
    this.prefs.setString(SharedPrefs.PREF_NOTIF_TOKEN, token);
  }
}